import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ReturnChequeRequest,
  ReturnChequeResponse,
  ReturnedChequeListDto,
  ReturnedChequeFilterDto,
} from '@/types/returnedCheque.types';

export const returnedChequeApi = {
  /** POST /api/v1/cheques/{id}/return — process a cheque return/dishonour */
  returnCheque: (id: string, data: ReturnChequeRequest) =>
    apiClient.post<ApiResponse<ReturnChequeResponse>>(`/cheques/${id}/return`, data),

  /** GET /api/v1/cheques/returned — paginated list of returned cheques */
  getReturnedCheques: (filter?: ReturnedChequeFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ReturnedChequeListDto>>>('/cheques/returned', {
      params: filter,
    }),
};
